export default {
    url: '/offers_see_activity',
    template: require('./view.html'),
    reloadOnSearch: false,
    data: {
        priority: 801,
        title: 'Special Offers Seen',
        role: 'offers',
    },
};
